"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPInput = void 0;
const react_1 = __importStar(require("react"));
const OTPInput_styles_1 = require("./OTPInput.styles");
const atoms_1 = require("../../atoms");
exports.OTPInput = ({ numInputs, label, otp, error, errorText, inputType, setOtp, setShowKeyboard, ...inputProps }) => {
    const getOtpDigits = () => {
        return otp
            ? otp.split('').map((digit) => digit.trim() || '')
            : Array(numInputs).fill('');
    };
    const [otpDigit, setOtpDigits] = react_1.useState(getOtpDigits());
    const [backspacePressed, setBackspacePressed] = react_1.useState(false);
    const inputRefs = react_1.useMemo(() => Array(numInputs)
        .fill(0)
        .map(() => react_1.default.createRef()), []);
    const focusPrevious = (key, index) => {
        if (key === 'Backspace' && index !== 0) {
            setBackspacePressed(true);
        }
    };
    const handleTextChange = (index, value) => {
        const newOtp = otpDigit;
        newOtp[index] = `${value}`;
        setOtpDigits([...newOtp]);
        if (index < numInputs - 1 && value) {
            inputRefs[index + 1].current?.focus();
        }
        if (index === numInputs - 1) {
            inputRefs[index].current?.blur();
            setShowKeyboard(false);
        }
        if (backspacePressed) {
            inputRefs[index - 1].current?.focus();
            setBackspacePressed(false);
        }
    };
    react_1.useEffect(() => {
        let otp = '';
        for (let index = 0; index < numInputs; index += 1) {
            otp += otpDigit[index] ? otpDigit[index] : ' ';
        }
        setOtp(otp);
    }, [otpDigit]);
    react_1.useEffect(() => {
        setOtpDigits(getOtpDigits());
    }, [otp]);
    const onInputFocus = () => {
        setShowKeyboard(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && react_1.default.createElement(OTPInput_styles_1.StyledLabel, { testID: "otp-label" }, label),
        react_1.default.createElement(OTPInput_styles_1.Row, null, otpDigit.map((_digit, index) => {
            const id = index;
            return (react_1.default.createElement(OTPInput_styles_1.DigitInput, Object.assign({ error: !!error, keyboardType: "number-pad", maxLength: 1, value: otpDigit[index], onFocus: onInputFocus, selectTextOnFocus: true, onChangeText: (val) => handleTextChange(index, val), onKeyPress: (e) => focusPrevious(e.nativeEvent.key, index), ref: inputRefs[index], testID: "otpInput", textContentType: inputType, key: id }, inputProps)));
        })),
        error && (react_1.default.createElement(OTPInput_styles_1.HelpTextContainer, null,
            react_1.default.createElement(atoms_1.HelpText, { testID: "ErrorLabel", type: atoms_1.HelpTextType.ERROR }, errorText)))));
};
